export const getRerenrollmentStatus = (status) => {
  switch (status) {
    case 'not-done':
      return 'Não realizada';
    case 'will-do':
      return 'Vai realizar';
    case 'will-not-do':
      return 'Não vai realizar';
    case 'maybe':
      return 'Talvez realizará';
    case 'under-negotiation':
      return 'Em negociação';
    case 'done':
      return 'Realizada';
    default:
      return status;
  }
}; 

export const getRelationship = (relationship) => {
  switch (relationship) {
    case 'father':
      return 'pai'
    case 'mother':
      return 'mãe'
    case 'caregiver':
      return 'responsável'
    case 'other':
      return 'outro'
    default:
      break;
  }
}


export const permissionsFactory = (grantedPermissions) => {
  const hasPermission = (requiredPermissions, grantedPermissions) => {
    return requiredPermissions.some(permission => grantedPermissions.includes(permission));
  }
  return {
    canViewStudent: hasPermission(['students.view_student'], grantedPermissions),
    canViewUser: hasPermission(['authentication.view_user'], grantedPermissions),
    canViewGroup: hasPermission(['auth.view_group'], grantedPermissions),
    canViewReport: hasPermission(['reports.view_report'], grantedPermissions),
    canManageReenrollment: hasPermission(['authentication.reenrollment_management'], grantedPermissions),
  }
}